import axios from 'axios'
import { getCookie } from '../../../Helper/cookieHelper'
import { getUrlDomainConfigNameByUrl } from '../../../Helper/urlHelper'
// axios.defaults.withCredentials = true
// axios.defaults.headers.common['Authorization'] = 'Bearer token'
// axios.defaults.headers.common['authorization'] = 'Bearer token'

export function request(url, method, payload = {}, headers = {}, params = {}, auth = {}, rest, controller) {
  if (localStorage.getItem('IS_INTERNET_ACTIVE')) return
  const base = getUrlDomainConfigNameByUrl(url)
  // const base = null
  //base null

  const token = getCookie('AUTH_TOKEN')
  return axios
    .request({
      baseURL: base || process.env.REACT_APP_API_URL,
      // withCredentials: true,
      url,
      data: JSON.parse(JSON.stringify(payload)),
      method,
      headers: {
        'Content-Type': 'application/json',
        // Must be application/json so Laravel FormRequest returns 422 JSON instead of
        // 302 redirect to the Referer (which browsers report as a CORS failure).
        Accept: 'application/json',
        authorization: token && token !== 'undefined' ? `Bearer ${token}` : 'Bearer token',
        ...headers,
      },
      params,
      // auth,
      ...rest,
      signal: controller?.signal,
    })
    .then((response) => {
      return response
    })
    .catch((error) => {
      if (error.response?.status === 401 && !url?.includes('logout')) {
        window.location.href = '/logout'
        return error.response
      } else {
        return error.response
      }
      // if (!error.response || error.response.status === 500) {
      //   window.location.href = '/#/response/error'
      // } else if (error.response.status === 401) {
      //   window.location.href = '/#/logout'
      //   return error.response
      // } else {
      //   return error.response
      // }
    })
}
